/* src/index.js */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import 'font-awesome/css/font-awesome.min.css'; // Import Font Awesome CSS
import App from './App.tsx';

// Create the root element using createRoot
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the app with StrictMode (Optional but recommended)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
